import React from 'react';
import { connect } from 'react-redux';
import { setCurrentPage, setPlanDetails } from '../../../General/Actions';
import AnimationWrapper from '../../../Utils/animationWrapper.js';
import AddonsPartComponent from './AllAddonsComponent';
import ConfirmationPartComponent from './AddonConfirmationComponent';
import SummaryPartComponent from './AddonSummaryComponent';
import ServicesComponent from '../UpgradeOffer/UpgradeOfferServicesComponent';
import FnFAddonsPart from './FnFAddonsComponent';
import PlanComparisonComponent from '../UpgradeOffer/PlanComparisonComponent';

class AcivateAddonRootComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           
        }
    }
 
    componentDidMount() {
      
    }
  
    render() {
            return (
                <div id="changePlanOuterMainContainer">
                        <AnimationWrapper.switchTransition
                                    switchTrigger={this.props.currentPage.pageName}
                                    triggerValueForChild0="addons"
                                    triggerValueForChild1="fnfAddons"
                                    triggerValueForChild2="services"
                                    triggerValueForChild3="planComparison"
                                    triggerValueForChild4="confirmation"
                                    triggerValueForChild5="summary"
                                    classNames={{ enterActive: 'notransition', exitActive: 'notransition'}}
                                    timeout="0"
                                >
                                
                               
                                <AddonsPartComponent />
                                <FnFAddonsPart />
                                <ServicesComponent />
                                <PlanComparisonComponent />
                                <ConfirmationPartComponent />
                                <SummaryPartComponent />
                            </AnimationWrapper.switchTransition>
                </div>
            )
        }
    }
    

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        currentPage: state.currentPage,
        planDetails:state.planDetails,
        cache : state.cache
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCurrentPage: function (key, payload) {
            dispatch(setCurrentPage(key, payload));
        },
        setPlanDetails: function (key, payload) {
            dispatch(setPlanDetails(key, payload));
        },
    }
}

const AcivateAddonRootComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AcivateAddonRootComponent)


export default AcivateAddonRootComponentContainer;